import { createSelector } from 'reselect';
import { getState } from 'store/utils';

export const getAdminTasksStore = createSelector(getState, (state) => state.adminTasks);
export const getAdminTasksData = createSelector(getAdminTasksStore, (state) => state.adminTasksData);
export const getAdminTasksInfo = createSelector(getAdminTasksData, (state) => state.taskInfo);
